import { render, staticRenderFns } from "./CbsDashboardItem.vue?vue&type=template&id=b6502348&scoped=true"
import script from "./CbsDashboardItem.vue?vue&type=script&lang=js"
export * from "./CbsDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6502348",
  null
  
)

export default component.exports